import { z } from 'zod';
import { EditorSlideBaseSchema, PlayerSlideBaseSchema } from './BaseSlide';

// Change from enum to const enum to prevent merging issues
export const enum FrontendStatus {
  NEW = 'new',
  MODIFIED = 'modified',
  MODIFIED_STRUCTURE = 'modifiedStructure',
  UNCHANGED = 'unchanged',
}

export const FrontendStatusSchema = z.enum([
  FrontendStatus.NEW,
  FrontendStatus.MODIFIED,
  FrontendStatus.MODIFIED_STRUCTURE,
  FrontendStatus.UNCHANGED,
]);

export enum AssetType {
  IMAGE = 'image',
  VIDEO = 'video',
  WEB = 'web.url',
}

export const AssetTypeSchema = z.enum([
  AssetType.IMAGE,
  AssetType.VIDEO,
  AssetType.WEB,
]);

// Slide content schema (presentation)
const SlideContentSchema = PlayerSlideBaseSchema.extend({
  url: z.string(),
  index: z.number(),
  slideGroupName: z.string(),
  queryParams: z.string().optional(),
});

// Stored slide schema (database/backend)
const StoredSlideSchema = EditorSlideBaseSchema.extend({
  archived: z.boolean(),
  createdAt: z.string(),
  createdBy: z.string(),
  changedAt: z.string(),
  changedBy: z.string(),
  desc: z.string(),
  origin: z.string(),
  ref: z.string(),
  readAccess: z.array(z.string()),
  writeAccess: z.array(z.string()),
  size: z.number(),
  type: AssetTypeSchema.optional(),
  filePath: z.string(),
  customer: z.string(),
  disabled: z.boolean(),
});

// Frontend slide schema (UI-specific)
const FrontendSlideSchema = EditorSlideBaseSchema.extend({
  index: z.number().optional(),
  type: AssetTypeSchema.optional(),
  size: z.number().optional(),
  splitScreen: z.boolean().optional(),
  customer: z.string().optional(),
  file: z.any().optional(),
  __frontendInternalStatus: FrontendStatusSchema.optional(),
});

export type StoredSlide = z.infer<typeof StoredSlideSchema>;
export type SlideContent = z.infer<typeof SlideContentSchema>;
export type FrontendSlide = z.infer<typeof FrontendSlideSchema>;

// Export schemas
export { StoredSlideSchema, SlideContentSchema, FrontendSlideSchema };
